import { render } from "./settings.vue?vue&type=template&id=b90124fc&scoped=true&ts=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=b90124fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/streamgames-customer-portal/streamgames-customer-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90124fc"]])

export default __exports__